/*
 * Copyright (c) 2023-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-back-to-esci',
    templateUrl: './back-to-esci.component.html',
    standalone: false
})
export class BackToEsciComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.location.assign(environment.apiUrl);
  }

}
